import Vue from 'vue';
import { Auth } from 'aws-amplify';
import VueRouter from 'vue-router';
import store from '../store/index';
Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    redirect: '/users/all',
  },
  {
    path: 'users',
    redirect: '/users/all',
  },
  {
    path: '*',
    redirect: '/users/all',
  },
  {
    path: '/collections',
    name: 'collections',
    props: true,
    params: true,
    component: () => import('@/views/Collections'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/workspaces',
    name: 'workspaces',
    props: true,
    params: true,
    component: () => import('@/views/Workspaces'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/site-configuration',
    name: 'site-settings',
    props: true,
    params: true,
    component: () => import('@/views/SiteSettings'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    props: true,
    params: true,
    component: () => import('@/views/login/index.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    props: true,
    params: true,
    component: () => import('@/views/resetPassword/index.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/confirm-reset-password',
    name: 'confirm-reset-password',
    props: true,
    params: true,
    component: () => import('@/views/confirmResetPassword/index.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/users/:mode',
    name: 'users',
    props: true,
    params: true,
    component: () => import('@/views/users/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change-password',
    name: 'change-password',
    props: true,
    params: true,
    component: () => import('@/views/changePassword/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/complete-new-password',
    name: 'complete-new-password',
    props: true,
    params: true,
    component: () => import('@/views/completeNewPassword/index.vue'),
    meta: {
      requiresAuth: false,
    },
  },
];
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  },
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    (async () => {
      try {
        const response = await Auth.currentAuthenticatedUser();
        if (response.signInUserSession) {
          const { state, commit, dispatch } = store;
          commit('setUserInfo', response.signInUserSession.idToken.payload);
          if (state.userInfo === null) {
            next({
              name: 'login',
            });
          } else {
            await dispatch('SiteConfiguration/getListFeatureFlags');
            next(); // go to wherever I'm going
          }
        }
      } catch (err) {
        next({
          name: 'login',
        });
        console.log('err', err);
      }
    })();
  } else {
    next(); // go to wherever I'm going
  }
});
export default router;
